import dayjs from "dayjs";

export type DateRangePreset = { label: string; value: [dayjs.Dayjs, dayjs.Dayjs] };

export const RANGE_PRESETS: DateRangePreset[] = [
	{ label: "Bugun", value: [dayjs().startOf("day"), dayjs().endOf("day")] },
	{
		label: "Kecha",
		value: [dayjs().subtract(1, "day").startOf("day"), dayjs().subtract(1, "day").endOf("day")],
	},
	{ label: "Ohirgi 3 kun", value: [dayjs().subtract(3, "day"), dayjs()] },
	{ label: "Ohirgi 1 hafta", value: [dayjs().subtract(7, "day"), dayjs()] },
	{ label: "Ohirgi 2 hafta", value: [dayjs().subtract(14, "day"), dayjs()] },
	{ label: "Ohirgi 1 oy", value: [dayjs().subtract(1, "month"), dayjs()] },
];

export const DEFAULT_DATE_RANGE = {
	start: dayjs().format("YYYY-MM-DD"),
	end: dayjs().format("YYYY-MM-DD"),
} as const;
